import { format } from "date-fns";
import { Filter, RefreshCcw, Calendar, Building2 } from "lucide-react";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const COLORS = {
 primary: "#003087",
 secondary: "#FFD100",
};

export const DashboardFilters = ({ onFilter, onExport, isLoading, counselors = [] }) => {
 const [dateRange, setDateRange] = useState([null, null]);
 const [metrics, setMetrics] = useState([]);
 const [serviceType, setServiceType] = useState("");
 const [counselorId, setCounselorId] = useState("");

 const handleFilter = () => {
   const [startDate, endDate] = dateRange;
   if (startDate && endDate && startDate > endDate) {
     alert("Start date must be before end date");
     return;
   }

   onFilter({
     startDate: startDate ? format(startDate, "yyyy-MM-dd") : null,
     endDate: endDate ? format(endDate, "yyyy-MM-dd") : null,
     metrics,
     serviceType,
     // counselorId, // Removed counselorId from filter payload
   });
 };

 return (
   <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800 p-4 mb-6">
     <div className="flex justify-between items-center mb-4">
       <h2 className="text-lg font-medium flex items-center text-gray-900 dark:text-white">
         <Filter className="w-5 h-5 mr-2" style={{ color: COLORS.primary }} />
         Filter Analytics
       </h2>
     </div>

     <div className="grid grid-cols-1 md:grid-cols-3 gap-4"> {/* Changed grid-cols-4 to grid-cols-3 */}
       <div>
         <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
           <Calendar className="w-4 h-4 inline-block mr-2" />
           Date Range
         </label>
         <DatePicker
           selectsRange
           startDate={dateRange[0]}
           endDate={dateRange[1]}
           onChange={setDateRange}
           className="w-full border border-gray-300 dark:border-gray-700 dark:bg-slate-900 dark:text-white rounded-md px-3 py-1.5 text-sm focus:ring-1 focus:ring-[#003087]"
           disabled={isLoading}
           placeholderText="Select date range"
         />
       </div>

       <div>
         <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
           <Building2 className="w-4 h-4 inline-block mr-2" />
           Service Type
         </label>
         <select
           className="w-full border border-gray-300 dark:border-gray-700 dark:bg-slate-900 dark:text-white rounded-md px-3 py-1.5 text-sm focus:ring-1 focus:ring-[#003087]"
           value={serviceType}
           onChange={(e) => setServiceType(e.target.value)}
           disabled={isLoading}
         >
           <option value="">All Services</option>
           <option value="personal-counseling">Personal Counseling</option>
           {/* <option value="vct">VCT</option>
           <option value="consultation">Consultation</option> */}
           <option value="couple-therapy">Couple Therapy</option>
           <option value="family-counseling">Family Counseling</option>
           <option value="group-therapy">Group Therapy</option>
         </select>
       </div>

       <div className="flex items-end">
         <button
           onClick={handleFilter}
           disabled={isLoading}
           className="w-full flex items-center justify-center px-4 py-1.5 bg-[#003087] text-white rounded-md hover:bg-[#002670] transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
         >
           {isLoading ? (
             <RefreshCcw className="w-4 h-4 animate-spin" />
           ) : (
             <>
               <Filter className="w-4 h-4 mr-2" />
               Apply Filters
             </>
           )}
         </button>
       </div>
     </div>
   </div>
 );
};